import React from "react";
import { classNames } from "../../helpers";
import LoadingSpinner from "../LoadingSpinner";

type ButtonModalProps = {
  viewType: string;
  type: any;
  creatingCandidateStatus: boolean;
  classStyle: string;
  setActionStatus: React.Dispatch<React.SetStateAction<string>>;
  changeValue?: any;
  children: JSX.Element;
  cypressSelector?: string;
  onClick?: () => void;
};

const FooterModelButton = (props: ButtonModalProps) => {
  const {
    type,
    classStyle,
    creatingCandidateStatus,
    children,
    viewType,
    setActionStatus,
    changeValue,
    cypressSelector,
    onClick,
  } = props;
  return (
    <button
      type={type}
      form="addCandidate"
      className={classNames(classStyle)}
      onClick={() => {
        if (viewType?.toString().trim() !== "") setActionStatus(viewType);
        !!changeValue && changeValue();
        !!onClick && onClick();
      }}
      data-cy={cypressSelector}
    >
      <div
        className={classNames(
          `absolute inset-0 flex justify-center items-center`,
          !creatingCandidateStatus && "hidden"
        )}
      >
        <LoadingSpinner size={20} />
      </div>
      <span className={classNames(creatingCandidateStatus && "invisible")}>
        {children}
      </span>
    </button>
  );
};

export default FooterModelButton;
